export const GtmClickEventDirectiveModule = angular
    .module('app.directives.gtmClickEvent', [])
    .directive('gtmClickEvent', ($window) => {
        return {
            restrict: 'A',
            link: (scope, element, attrs) => {
                let logGtmEvent = () => {
                    if (typeof $window.dataLayer !== 'undefined') {
                        $window.dataLayer.push({
                            event: attrs.gtmClickEvent
                        });
                    }
                };

                element.on('click touchstart', logGtmEvent);
                scope.$on('$destroy', () => {
                    element.off('click touchstart', logGtmEvent);
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/gtmClickEvent.directive.js